import * as _ from "lodash-es";
import React, { ChangeEvent, Component } from "react";
import qbBtnDefault from "../../../../assets/images/quickbooks/C2QB_green_btn_tall_default.svg";
import quickbooksLogo from "../../../../assets/images/quickbooks/QuickBooks Logo_Horz_Rev.png";
import quickbooksLightLogo from "../../../../assets/images/quickbooks/QuickBooks Logo_Horz.png";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import IGetCatalogsDTO from "../../../../models/DTO/IGetCatalogsDTO";
import IGetPriceGroupsDTO from "../../../../models/DTO/IGetPriceGroupsDTO";
import ILoadUserDTO from "../../../../models/DTO/ILoadUserDTO";
import IOnGetCatalogsDTO from "../../../../models/DTO/IOnGetCatalogsDTO";
import IOnGetPriceGroupsDTO from "../../../../models/DTO/IOnGetPriceGroupsDTO";
import IOnLoadUserDTO from "../../../../models/DTO/IOnLoadUserDTO";
import IOnQBOGetIncomeAccountsDTO from "../../../../models/DTO/IOnQBOGetIncomeAccountsDTO";
import IOnQBOGetTermsDTO from "../../../../models/DTO/IOnQBOGetTermsDTO";
import IOnQBOSetCatalogItemIncomeAccountDTO from "../../../../models/DTO/IOnQBOSetCatalogItemIncomeAccountDTO";
import IOnQBOSetDefaultPOFieldDTO from "../../../../models/DTO/IOnQBOSetDefaultPOFieldDTO";
import IOnQBOSetDefaultSalesTermDTO from "../../../../models/DTO/IOnQBOSetDefaultSalesTermDTO";
import IOnUpdateSupplierIntegrationsDTO from "../../../../models/DTO/IOnUpdateSupplierIntegrationsDTO";
import IQBOGetAccountsDTO from "../../../../models/DTO/IQBOGetAccountsDTO";
import IQBOOnGetAccountsDTO from "../../../../models/DTO/IQBOOnGetAccountsDTO";
import IQBOOnGetOtherCurrentAssetAccountsDTO from "../../../../models/DTO/IQBOOnGetOtherCurrentAssetAccountsDTO";
import IQBOOnOAuthDisconnectDTO from "../../../../models/DTO/IQBOOnOAuthDisconnectDTO";
import IQBOOnOAuthStartDTO from "../../../../models/DTO/IQBOOnOAuthStartDTO";
import IQBOSetCatalogItemIncomeAccountDTO from "../../../../models/DTO/IQBOSetCatalogItemIncomeAccountDTO";
import IQBOSetDefaultPOFieldDTO from "../../../../models/DTO/IQBOSetDefaultPOFieldDTO";
import IQBOSetDefaultSalesTermDTO from "../../../../models/DTO/IQBOSetDefaultSalesTermDTO";
import IUpdateSupplierIntegrationsDTO from "../../../../models/DTO/IUpdateSupplierIntegrationsDTO";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import ICatalog from "../../../../models/ICatalog";
import INotification from "../../../../models/INotification";
import IPrice_Group from "../../../../models/IPrice_Group";
import ISupplier_Integration from "../../../../models/ISupplier_Integration";
import ISupplierModel from "../../../../models/ISupplierModel";
import IUserUI from "../../../../models/IUserUI";
import NotificationLevelEnum from "../../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../../models/NotificationPositionEnum";
import QBOAccountTypeEnum from "../../../../models/QBOAccountTypeEnum";
import IQBOAccountDTO from "../../../../models/QuickBooks Online/IQBOAccountDTO";
import { OwAccordion } from "../../../shared/OwAccordion/OwAccordion";
import OwBadge from "../../../shared/OwBadge/OwBadge";
import OwButton from "../../../shared/OwButton/OwButton";
import OwCheckbox from "../../../shared/OwCheckbox/OwCheckbox";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import OwSelectOption from "../../../shared/OwSelectOption/OwSelectOption";
import OwToggle from "../../../shared/OwToggle/OwToggle";
import WhatsThis from "../../../shared/WhatsThis/WhatsThis";
import "./QuickbooksConnect.scss";
import IQBOGetPreferencesDTO from "../../../../models/DTO/IQBOGetPreferencesDTO";
import IQBOOnGetPreferencesDTO from "../../../../models/DTO/IQBOOnGetPreferencesDTO";
import OwTextArea from "../../../shared/OwTextArea/OwTextArea";
import { Socket } from "socket.io-client";
import Typeahead from "../../../shared/Typeahead/Typeahead";
import ITypeaheadCatalogItemDTO from "../../../../models/DTO/ITypeaheadCatalogItemDTO";
import IOnTypeaheadCatalogItemDTO from "../../../../models/DTO/IOnTypeaheadCatalogItemDTO";
import ICatalog_Item from "../../../../models/ICatalog_Item";
import IUiSocketSetup from "../../../../models/IUiSocketSetup";
import IOnQBOGetCustomSalesFieldsDTO from "../../../../models/DTO/IOnQBOGetCustomSalesFieldsDTO";
import IQBOCustomFieldDTO from "../../../../models/QuickBooks Online/IQBOCustomFieldDTO";
import IQBOForceCustomFieldActiveDTO from "../../../../models/DTO/IQBOForceCustomFieldActiveDTO";
import QBOGroupedInvoiceTypeEnum from "../../../../models/QBOGroupedInvoiceTypeEnum";
import { isNil } from "lodash-es";
import QBOInvoiceDateFieldEnum from "@models/QBOInvoiceDateFieldEnum";
import QBOGlobalTaxCalculationEnum from "../../../../models/QBOGlobalTaxCalculationEnum";
import { OwIconTooltip } from "@components/shared/OwIconTooltip/OwIconTooltip";

type Props = {
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    setActivityIndicator: (activityIndicator: boolean) => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    isMainViewLight?: boolean;
    catalogs: ICatalog[];
    showHiddenFeatures: boolean;
};

type State = {
    qboOtherCurrentAssetAccounts: IQBOAccountDTO[];
    qboCOGSAccounts: IQBOAccountDTO[];
    qboIncomeAccounts: IQBOAccountDTO[];
    qboAPAccounts: IQBOAccountDTO[];
    qbo_InventoryAssetAccountId?: string;
    qbo_CatalogItemIncomeAcctId?: string;
    qbo_POCustomFieldId?: string;
    qbo_DefaultTermId?: string;
    showQboIncomeAccountHowTo: boolean;
    saveIncomeAcctActive: boolean;
    saveCustomFieldActive: boolean;
    saveTermFieldActive: boolean;
    qboTermOptions: any[];
    qboTermOptionsLoaded: boolean;
    showQboSalesTermsHowTo: boolean;
    qboCustomSalesFields: { Id: string | null; Name: string | undefined }[];
    qboRawCustomSalesFields: IQBOCustomFieldDTO[];
    showQboCustomSalesFieldsHowTo: boolean;
    incomeAccountComponent: any;
    poFieldComponent: any;
    termsComponent: any;
    catalogs: ICatalog[];
    priceGroups: IPrice_Group[];
    catalog_id?: number;
    price_group_id?: number;
    saveDefaultPriceGroupActive: boolean;
    qbo_RepGroupCustomFieldId?: string;
    qbo_SalesRepCustomFieldId?: string;
    saveInventoryAssetAcctActive: boolean;
    qbo_COGSAccountId?: string;
    qbo_COGSAccountName?: string;
    saveCOGSAccountActive: boolean;
    enable_payments: boolean;
    qbo_auto_pull_customers: boolean;
    qbo_auto_pull_products: boolean;
    qbo_update_accounts_on_save: boolean;
    qbo_ow_num_as_invoice_ref: boolean;
    qbo_use_ow_quote_num_for_estimate: boolean;
    qbo_CustomFieldValueOne?: any;
    qbo_CustomFieldValueTwo?: any;
    qbo_CustomFieldValueThree?: any;
    qbo_UsingAutoSalesTax: boolean;
    saveDefaultTaxRateActive: boolean;
    saveAPAccountActive: boolean;
    activeAutoSalesTax: boolean;
    qbo_AllowAchPayments: boolean;
    qbo_using_classes: boolean;
    qbo_po_default_ap_account?: { Id: string; Name: string };
    qbo_hide_quote_ow_btns: boolean;
    qbo_quote_for_est_name: boolean;
    qbo_invoice_memo?: string;
    foundShippingItems: ICatalog_Item[];
    selectedShippingItem?: ICatalog_Item | null;
    clearShippingItem: boolean;
    qbo_customer_name_field: "DisplayName" | "CompanyName" | null;
    qbo_grouped_invoices: boolean;
    // qbo_grouped_invoices_by_day: boolean;
    getCustomFieldsActive: boolean;
    qbo_grouped_invoice_type?: QBOGroupedInvoiceTypeEnum | null;
    qbo_invoice_default_date?: QBOInvoiceDateFieldEnum | null;
    qbo_invoice_default_ship_date?: QBOInvoiceDateFieldEnum | null;
    qbo_push_inventory_updates?: boolean;
    qbo_skip_inventory_updates?: boolean;
    qbo_GlobalTaxCalculationEnum?: QBOGlobalTaxCalculationEnum | null;
    qbo_TaxOnShippingAdjustment?: boolean;
};

class QuickbooksConnect extends Component<Props, State> {
    readonly state: State = {
        qboOtherCurrentAssetAccounts: [],
        qboCOGSAccounts: [],
        qboIncomeAccounts: [],
        qboAPAccounts: [],
        qboTermOptions: [],
        qboTermOptionsLoaded: false,
        qboCustomSalesFields: [],
        qboRawCustomSalesFields: [],
        saveIncomeAcctActive: false,
        saveCustomFieldActive: false,
        saveTermFieldActive: false,
        saveCOGSAccountActive: false,
        showQboIncomeAccountHowTo: false,
        showQboCustomSalesFieldsHowTo: false,
        showQboSalesTermsHowTo: false,
        incomeAccountComponent: null,
        poFieldComponent: null,
        termsComponent: null,
        catalogs: this.props.catalogs,
        priceGroups: [],
        saveDefaultPriceGroupActive: false,
        saveInventoryAssetAcctActive: false,
        enable_payments: true,
        qbo_auto_pull_customers: false,
        qbo_auto_pull_products: !!this.props.supplierModel.Supplier_Integration.qbo_auto_pull_products,
        qbo_update_accounts_on_save: !!this.props.supplierModel.Supplier_Integration.qbo_update_accounts_on_save,
        qbo_CustomFieldValueOne: this.props.supplierModel.Supplier_Integration.qbo_CustomFieldOne,
        qbo_CustomFieldValueTwo: this.props.supplierModel.Supplier_Integration.qbo_CustomFieldTwo,
        qbo_CustomFieldValueThree: this.props.supplierModel.Supplier_Integration.qbo_CustomFieldThree,
        qbo_ow_num_as_invoice_ref: !isNil(this.props.supplierModel.Supplier_Integration.qbo_ow_num_as_invoice_ref)
            ? this.props.supplierModel.Supplier_Integration.qbo_ow_num_as_invoice_ref
            : true,
        qbo_UsingAutoSalesTax: this.props.supplierModel.Supplier_Integration.qbo_UsingAutoSalesTax || false,
        qbo_po_default_ap_account: this.props.supplierModel.Supplier_Integration.qbo_po_default_ap_account,
        saveDefaultTaxRateActive: false,
        activeAutoSalesTax: false,
        saveAPAccountActive: false,
        qbo_use_ow_quote_num_for_estimate: this.props.supplierModel.Supplier_Integration.qbo_use_ow_quote_num_for_estimate || false,
        qbo_AllowAchPayments: this.props.supplierModel.Supplier_Integration.qbo_AllowAchPayments || false,
        qbo_using_classes: this.props.supplierModel.Supplier_Integration.qbo_using_classes || false,
        qbo_hide_quote_ow_btns: this.props.supplierModel.Supplier_Integration.qbo_hide_quote_ow_btns || false,
        qbo_quote_for_est_name: this.props.supplierModel.Supplier_Integration.qbo_quote_for_est_name || false,
        qbo_invoice_memo: this.props.supplierModel.Supplier_Integration.qbo_invoice_memo,
        foundShippingItems: [],
        selectedShippingItem: this.props.supplierModel.Supplier_Integration.QBO_Shipping_Catalog_Item || null,
        clearShippingItem: false,
        qbo_customer_name_field: this.props.supplierModel.Supplier_Integration.qbo_customer_name_field || null,
        qbo_grouped_invoices: this.props.supplierModel.Supplier_Integration.qbo_grouped_invoices || false,
        // qbo_grouped_invoices_by_day: this.props.supplierModel.Supplier_Integration.qbo_grouped_invoices_by_day || false,
        getCustomFieldsActive: true,
        qbo_grouped_invoice_type: this.props.supplierModel.Supplier_Integration.qbo_grouped_invoice_type || null,
        qbo_invoice_default_date: this.props.supplierModel.Supplier_Integration.qbo_invoice_default_date || null,
        qbo_invoice_default_ship_date: this.props.supplierModel.Supplier_Integration.qbo_invoice_default_ship_date || null,
        qbo_push_inventory_updates: this.props.supplierModel.Supplier_Integration.qbo_push_inventory_updates || false,
        qbo_GlobalTaxCalculationEnum: this.props.supplierModel.Supplier_Integration.qbo_GlobalTaxCalculationEnum || null,
        qbo_skip_inventory_updates: this.props.supplierModel.Supplier_Integration.qbo_skip_inventory_updates || false,
        qbo_TaxOnShippingAdjustment: this.props.supplierModel.Supplier_Integration.qbo_TaxOnShippingAdjustment || false,
    };

    sockets: IUiSocketSetup[] = [];

    qboInvoiceDateFieldOptions = [
        { title: "delivery_date", value: QBOInvoiceDateFieldEnum.DELIVERY_DATE },
        { title: "ship_date", value: QBOInvoiceDateFieldEnum.SHIP_DATE },
        { title: "due_date", value: QBOInvoiceDateFieldEnum.DUE_DATE },
        { title: "do_not_ship_before_date", value: QBOInvoiceDateFieldEnum.DO_NOT_SHIP_BEFORE_DATE },
        // { title: "submit_date", value: QBOInvoiceDateFieldEnum.SUBMIT_DATE },
        // { title: "confirmed_date", value: QBOInvoiceDateFieldEnum.CONFIRMED_DATE },
    ];

    qboGlobalTaxCalcOptions = [
        { title: "not_applicable", value: QBOGlobalTaxCalculationEnum.NOT_APPLICABLE },
        { title: "tax_excluded", value: QBOGlobalTaxCalculationEnum.TAX_EXCLUDED },
        { title: "tax_inclusive", value: QBOGlobalTaxCalculationEnum.TAX_INCLUSIVE },
    ];

    constructor(props: any) {
        super(props);

        this.sockets = [
            { endpoint: EndpointsEnum.QBOOnOAuthStart, fn: this.onQboOauthStart },
            { endpoint: EndpointsEnum.QBOOnOAuthDisconnect, fn: this.onQboOauthDisconnect },
            { endpoint: EndpointsEnum.QBOOnGetIncomeAccounts, fn: this.onQboGetIncomeAccounts },
            { endpoint: EndpointsEnum.QBOOnGetAccounts, fn: this.onQboGetAccounts },
            { endpoint: EndpointsEnum.QBOOnGetOtherCurrentAssetAccounts, fn: this.onQboGetOtherCurrentAssetAccounts },
            { endpoint: EndpointsEnum.QBOOnSetCatalogItemIncomeAccount, fn: this.onQboSetCatalogItemIncomeAccount },
            { endpoint: EndpointsEnum.QBOOnSetDefaultSalesTerm, fn: this.onQboSetDefaultSalesTerm },
            { endpoint: EndpointsEnum.QBOOnSetDefaultPOField, fn: this.onQboSetDefaultPOField },
            { endpoint: EndpointsEnum.QBOOnGetSalesTerms, fn: this.onQboGetTerms },
            { endpoint: EndpointsEnum.QBOOnGetCustomSalesFields, fn: this.onQboGetCustomSalesFields },
            { endpoint: EndpointsEnum.Notify, fn: this.notify },
            { endpoint: EndpointsEnum.AppOnLoadUser, fn: this.onLoadUser },
            { endpoint: EndpointsEnum.CatalogsOnGetCatalogs, fn: this.onGetCatalogs },
            { endpoint: EndpointsEnum.CatalogsOnGetPriceGroups, fn: this.onGetPriceGroups },
            { endpoint: EndpointsEnum.SupplierOnUpdateSupplierIntegrations, fn: this.onUpdateSupplierIntegrations },
            { endpoint: EndpointsEnum.QBOOnGetPreferences, fn: this.onGetPreferences },
            { endpoint: EndpointsEnum.CatalogItemOnTypeaheadCatalogItem, fn: this.onShippingItemLookup },
            { endpoint: EndpointsEnum.QBOOnForceCustomFieldActive, fn: this.onForceCustomFieldActive },
        ];
    }

    componentDidMount(): void {
        for (const socket of this.sockets) {
            this.props.socket.on(socket.endpoint, socket.fn);
        }

        // @ts-expect-error
        let supplierIntegrations: ISupplier_Integration = {};

        if (!_.isNil(this.props.supplierModel)) {
            supplierIntegrations = this.props.supplierModel.Supplier_Integration || {};
        }

        const state: any = {
            qbo_CatalogItemIncomeAcctId: supplierIntegrations.qbo_CatalogItemIncomeAcctId,
            qbo_InventoryAssetAccountId: supplierIntegrations.qbo_InventoryAssetAccountId,
            qbo_COGSAccountId: supplierIntegrations.qbo_COGSAccountId,
            qbo_POCustomFieldId: supplierIntegrations.qbo_POCustomFieldId,
            qbo_DefaultTermId: supplierIntegrations.qbo_DefaultTermId,
            qbo_SalesRepCustomFieldId: supplierIntegrations.qbo_SalesRepCustomFieldId,
            qbo_RepGroupCustomFieldId: supplierIntegrations.qbo_RepGroupCustomFieldId,
            incomeAccountComponent: null,
            poFieldComponent: null,
            termsComponent: null,
            qbo_auto_pull_customers: supplierIntegrations.qbo_auto_pull_customers,
            qbo_auto_pull_products: supplierIntegrations.qbo_auto_pull_products,
        };

        if (this.props.supplierModel.Supplier_Integration.has_qbo) {
            state.incomeAccountComponent = this.getIncomeAccountSelection();
            state.poFieldComponent = this.poCustomField();
            state.termsComponent = this.getDefaultSalesTerms();
        }

        this.setState(state, () => {
            if (supplierIntegrations.has_qbo) {
                this.props.socket.emit(EndpointsEnum.QBOGetCustomSalesFields, this.getQboPayload());
                this.props.socket.emit(EndpointsEnum.QBOGetIncomeAccounts, this.getQboPayload());
                this.props.socket.emit(EndpointsEnum.QBOGetSalesTerms, this.getQboPayload());
                this.props.socket.emit(EndpointsEnum.QBOGetOtherCurrentAssetAccounts, this.getQboPayload());

                this.getCOGSAccounts();
                this.qboGetAccounts(QBOAccountTypeEnum.ACCOUNTS_PAYABLE);
            }
        });
    }

    componentWillUnmount(): void {
        for (const socket of this.sockets) {
            this.props.socket.removeListener(socket.endpoint, socket.fn);
        }
    }

    getCOGSAccounts = () => {
        const payload: IQBOGetAccountsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            accountType: QBOAccountTypeEnum.COST_OF_GOOD_SOLD,
        };

        this.props.socket.emit(EndpointsEnum.QBOGetAccounts, payload);
    };

    onUpdateSupplierIntegrations = (data: IOnUpdateSupplierIntegrationsDTO) => {
        const notification: INotification = {
            message: "successfully_updated_integrations",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        this.props.notifyFn(null, notification);

        this.setState({
            saveDefaultPriceGroupActive: false,
            saveCustomFieldActive: false,
            saveInventoryAssetAcctActive: false,
            saveCOGSAccountActive: false,
            saveDefaultTaxRateActive: false,
            activeAutoSalesTax: false,
            saveAPAccountActive: false,
        });
    };

    getCatalogs = () => {
        const payload: IGetCatalogsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            callMeta: {
                view: "QuickbooksConnect",
                fn: "getCatalogs",
            },
        };

        this.props.socket.emit(EndpointsEnum.CatalogsGetCatalogs, payload);
    };

    onGetCatalogs = (data: IOnGetCatalogsDTO) => {
        this.setState(
            {
                catalogs: data.catalogs,
                catalog_id: this.props.supplierModel.Supplier_Integration.QBO_DefaultPriceGroup?.catalog_id || undefined,
            },
            () => {
                if (!this.state.priceGroups.length && this.state.catalog_id) {
                    this.getPriceGroups();
                }
            }
        );
    };

    getPriceGroups = () => {
        const catalog = this.state.catalogs.find((catalog) => {
            return Number(catalog.id) === Number(this.state.catalog_id);
        });

        if (catalog) {
            const payload: IGetPriceGroupsDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                catalogGuid: catalog.guid,
            };

            this.props.socket.emit(EndpointsEnum.CatalogsGetPriceGroups, payload);
        }
    };

    onGetPriceGroups = (data: IOnGetPriceGroupsDTO) => {
        this.setState({
            priceGroups: data.priceGroups,
            price_group_id: this.props.supplierModel.Supplier_Integration.QBO_DefaultPriceGroup?.id || undefined,
        });
    };

    onLoadUser = (data: IOnLoadUserDTO) => {
        if (data.supplier && data.supplier.Supplier_Integration) {
            if (!data.supplier.Supplier_Integration.has_qbo) {
                this.setState({
                    incomeAccountComponent: null,
                    poFieldComponent: null,
                    termsComponent: null,
                });
            }
        }
    };

    getQboPayload = () => {
        return {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };
    };

    notify = () => {
        this.setState({
            saveIncomeAcctActive: false,
        });
    };

    startQBConnect = () => {
        const payload = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            enable_payments: this.state.enable_payments,
        };

        this.props.socket.emit(EndpointsEnum.QBOOAuthStart, payload);
    };

    disconnectQuickbooks = () => {
        const payload = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.QBOOAuthDisconnect, payload);
    };

    onQboOauthStart = (data: IQBOOnOAuthStartDTO) => {
        console.log("onQboOauthStart: ", data);
        // @ts-expect-error
        window.location = data.url;
    };

    onQboOauthDisconnect = (data: IQBOOnOAuthDisconnectDTO) => {
        const payload: ILoadUserDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
        };

        this.props.socket.emit(EndpointsEnum.AppLoadUser, payload);
    };

    onQboGetIncomeAccounts = (data: IOnQBOGetIncomeAccountsDTO) => {
        this.setState(
            {
                qboIncomeAccounts: data.incomeAccounts,
            },
            () => {
                this.setState({
                    incomeAccountComponent: this.getIncomeAccountSelection(),
                });
            }
        );
        // console.log('onQboGetIncomeAccounts', data);
    };

    qboGetAccounts = (accountType: QBOAccountTypeEnum) => {
        const payload: IQBOGetAccountsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            accountType,
        };

        this.props.socket.emit(EndpointsEnum.QBOGetAccounts, payload);
    };

    onQboGetAccounts = (data: IQBOOnGetAccountsDTO) => {
        const state: any = {};

        switch (data.accountType) {
            case QBOAccountTypeEnum.COST_OF_GOOD_SOLD:
                state.qboCOGSAccounts = data.accounts;
                break;
            case QBOAccountTypeEnum.ACCOUNTS_PAYABLE:
                state.qboAPAccounts = data.accounts;
                break;
        }

        this.setState(state);
    };

    onQboGetOtherCurrentAssetAccounts = (data: IQBOOnGetOtherCurrentAssetAccountsDTO) => {
        this.setState({
            qboOtherCurrentAssetAccounts: data.accounts,
        });
    };

    onQboGetCustomSalesFields = (data: IOnQBOGetCustomSalesFieldsDTO) => {
        let qboCustomSalesFields: { Id: string | null; Name: string | undefined }[] = [];

        let qboRawCustomSalesFields: IQBOCustomFieldDTO[] = [];

        if (data.customSalesFields) {
            qboRawCustomSalesFields = data.customSalesFields;

            // console.log("fields", fields);

            qboCustomSalesFields = data.customSalesFields
                .filter((field) => field.Type === "StringType")
                .map((field) => {
                    const IdMatches = field.Name.match(/\d+/);

                    const Id = IdMatches ? IdMatches[0] : null;
                    const Name = field.StringValue;

                    return {
                        Id,
                        Name,
                    };
                });

            // console.log("qboCustomSalesFields", qboCustomSalesFields);
        }

        this.setState(
            {
                qboCustomSalesFields,
                qboRawCustomSalesFields,
                getCustomFieldsActive: false,
            },
            () => {
                this.setState({
                    poFieldComponent: this.poCustomField(),
                });
            }
        );
    };

    onQboGetTerms = (data: IOnQBOGetTermsDTO) => {
        // console.log("onQboGetTerms", data);
        this.setState(
            {
                qboTermOptions: data.termOptions,
                qboTermOptionsLoaded: true,
            },
            () => {
                this.setState({
                    termsComponent: this.getDefaultSalesTerms(),
                });
            }
        );
    };

    saveQboCatalogItemIncomeAcct = () => {
        this.setState(
            {
                saveIncomeAcctActive: true,
            },
            () => {
                const option: IQBOAccountDTO | undefined = this.state.qboIncomeAccounts.find((account: IQBOAccountDTO) => {
                    if (account.Id === this.state.qbo_CatalogItemIncomeAcctId) {
                        return account;
                    }
                });

                if (option) {
                    const payload: IQBOSetCatalogItemIncomeAccountDTO = {
                        userToken: this.props.userModel.token,
                        userGuid: this.props.userModel.guid,
                        supplierGuid: this.props.supplierModel.guid,
                        incomeAccount: option,
                    };

                    this.props.socket.emit(EndpointsEnum.QBOSetCatalogItemIncomeAccount, payload);
                }
            }
        );
    };

    saveAutoSalesTax = () => {
        this.setState(
            {
                activeAutoSalesTax: true,
            },
            () => {
                const payload: IUpdateSupplierIntegrationsDTO = {
                    userToken: this.props.userModel.token,
                    userGuid: this.props.userModel.guid,
                    supplierGuid: this.props.supplierModel.guid,
                    // @ts-expect-error
                    Supplier_Integration: {
                        qbo_UsingAutoSalesTax: this.state.qbo_UsingAutoSalesTax,
                        qbo_TaxOnShippingAdjustment: this.state.qbo_TaxOnShippingAdjustment,
                    },
                };

                this.props.socket.emit(EndpointsEnum.SupplierUpdateSupplierIntegrations, payload);
            }
        );
    };

    saveQboInventoryAssetAcct = () => {
        this.setState(
            {
                saveInventoryAssetAcctActive: true,
            },
            () => {
                const option: IQBOAccountDTO | undefined = this.state.qboOtherCurrentAssetAccounts.find((account: IQBOAccountDTO) => {
                    if (account.Id === this.state.qbo_InventoryAssetAccountId) {
                        return account;
                    }
                });

                if (option) {
                    const payload: IUpdateSupplierIntegrationsDTO = {
                        userToken: this.props.userModel.token,
                        userGuid: this.props.userModel.guid,
                        supplierGuid: this.props.supplierModel.guid,
                        // @ts-expect-error
                        Supplier_Integration: {
                            qbo_InventoryAssetAccountId: option.Id,
                            qbo_InventoryAssetAccountName: option.Name,
                        },
                    };

                    this.props.socket.emit(EndpointsEnum.SupplierUpdateSupplierIntegrations, payload);
                }
            }
        );
    };

    saveQBOCOGSAccount = () => {
        this.setState(
            {
                saveCOGSAccountActive: true,
            },
            () => {
                const option: IQBOAccountDTO | undefined = this.state.qboCOGSAccounts.find((account: IQBOAccountDTO) => {
                    if (account.Id === this.state.qbo_COGSAccountId) {
                        return account;
                    }
                });

                if (option) {
                    const payload: IUpdateSupplierIntegrationsDTO = {
                        userToken: this.props.userModel.token,
                        userGuid: this.props.userModel.guid,
                        supplierGuid: this.props.supplierModel.guid,
                        // @ts-expect-error
                        Supplier_Integration: {
                            qbo_COGSAccountId: option.Id,
                            qbo_COGSAccountName: option.Name,
                        },
                    };

                    this.props.socket.emit(EndpointsEnum.SupplierUpdateSupplierIntegrations, payload);
                }
            }
        );
    };

    saveQBOAPAccount = () => {
        this.setState(
            {
                saveAPAccountActive: true,
            },
            () => {
                const option: IQBOAccountDTO | undefined = this.state.qboAPAccounts.find((account: IQBOAccountDTO) => {
                    if (account.Id === this.state.qbo_po_default_ap_account?.Id) {
                        return account;
                    }
                });

                if (option) {
                    const payload: IUpdateSupplierIntegrationsDTO = {
                        userToken: this.props.userModel.token,
                        userGuid: this.props.userModel.guid,
                        supplierGuid: this.props.supplierModel.guid,
                        // @ts-expect-error
                        Supplier_Integration: {
                            qbo_po_default_ap_account: option,
                        },
                    };

                    this.props.socket.emit(EndpointsEnum.SupplierUpdateSupplierIntegrations, payload);
                }
            }
        );
    };

    saveCustomSalesField = () => {
        this.setState(
            {
                saveCustomFieldActive: true,
            },
            () => {
                const option = this.state.qboCustomSalesFields.find((customField) => {
                    if (customField.Id === this.state.qbo_POCustomFieldId) {
                        return customField;
                    }
                });

                if (option) {
                    const payload: IQBOSetDefaultPOFieldDTO = {
                        userToken: this.props.userModel.token,
                        userGuid: this.props.userModel.guid,
                        supplierGuid: this.props.supplierModel.guid,
                        // @ts-expect-error
                        customField: option,
                    };

                    this.props.socket.emit(EndpointsEnum.QBOSetDefaultPOField, payload);
                }
            }
        );
    };

    toggleQBOPayments = () => {
        const payload: IUpdateSupplierIntegrationsDTO = {
            userToken: this.props.userModel.token,
            userGuid: this.props.userModel.guid,
            supplierGuid: this.props.supplierModel.guid,
            // @ts-expect-error
            Supplier_Integration: {
                has_qbo_payments: !this.props.supplierModel.Supplier_Integration.has_qbo_payments,
            },
        };

        this.props.socket.emit(EndpointsEnum.SupplierUpdateSupplierIntegrations, payload);
    };

    saveDefaultPriceGroup = () => {
        const payload: IUpdateSupplierIntegrationsDTO = {
            userToken: this.props.userModel.token,
            userGuid: this.props.userModel.guid,
            supplierGuid: this.props.supplierModel.guid,
            // @ts-expect-error
            Supplier_Integration: {
                qbo_DefaultPriceGroup: this.state.price_group_id,
            },
        };

        this.props.socket.emit(EndpointsEnum.SupplierUpdateSupplierIntegrations, payload);

        this.setState({
            saveDefaultPriceGroupActive: true,
        });
    };

    saveQboTerm = () => {
        this.setState(
            {
                saveTermFieldActive: true,
            },
            () => {
                const option = _.find(this.state.qboTermOptions, (termOption) => {
                    if (termOption.Id === this.state.qbo_DefaultTermId) {
                        return termOption;
                    }
                });

                const payload: IQBOSetDefaultSalesTermDTO = {
                    userToken: this.props.userModel.token,
                    userGuid: this.props.userModel.guid,
                    supplierGuid: this.props.supplierModel.guid,
                    salesTerm: option,
                };

                this.props.socket.emit(EndpointsEnum.QBOSetDefaultSalesTerm, payload);
            }
        );
    };

    loadUser = () => {
        const payload: ILoadUserDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
        };

        this.props.socket.emit(EndpointsEnum.AppLoadUser, payload);
    };

    onQboSetCatalogItemIncomeAccount = (data: IOnQBOSetCatalogItemIncomeAccountDTO) => {
        const notification: INotification = {
            title: "saved_catalog_item_income_account",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.br,
        };

        this.props.notifyFn(null, notification);

        this.setState(
            {
                saveIncomeAcctActive: false,
            },
            () => {
                this.loadUser();
            }
        );
    };

    onQboSetDefaultSalesTerm = (data: IOnQBOSetDefaultSalesTermDTO) => {
        const notification: INotification = {
            title: "saved_default_sales_term",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.br,
        };

        this.props.notifyFn(null, notification);

        this.setState(
            {
                saveTermFieldActive: false,
            },
            () => {
                this.loadUser();
            }
        );
    };

    onQboSetDefaultPOField = (data: IOnQBOSetDefaultPOFieldDTO) => {
        const notification: INotification = {
            title: "saved_po_custom_field",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.br,
        };

        this.props.notifyFn(null, notification);

        this.setState(
            {
                saveCustomFieldActive: false,
            },
            () => {
                this.loadUser();
            }
        );
    };

    getIncomeAccountSelection = () => {
        if (!this.state.qboIncomeAccounts?.length) {
            return (
                <div className="col-12">
                    <OwLabel leftIconClass={"far fa-circle-notch fa-spin"} title={"loading_income_account_options"} />
                </div>
            );
        } else {
            return (
                <div className="col-12">
                    <div>
                        <div className={"col-12"}>
                            <OwLabel className={"me-2"} title={"default_catalog_item_income_account"} />

                            <WhatsThis subject={"help_text_qbo_default_catalog_item_income_account"} />
                        </div>
                        <div className={"col-12 mb-2"}>
                            {this.state.qboIncomeAccounts ? (
                                <OwSelectOption
                                    options={this.state.qboIncomeAccounts}
                                    valueProp={"Id"}
                                    titleProp={"Name"}
                                    fn={this.handleChange}
                                    selectedOption={this.state}
                                    selectedOptionProp={"qbo_CatalogItemIncomeAcctId"}
                                    name={"qbo_CatalogItemIncomeAcctId"}
                                    showBlankFirst={true}
                                />
                            ) : null}
                        </div>
                        <div className={"col-12"}>
                            <OwButton
                                disabled={this.state.saveIncomeAcctActive}
                                active={this.state.saveIncomeAcctActive}
                                fn={this.saveQboCatalogItemIncomeAcct}
                                title={"save"}
                            />
                        </div>
                    </div>
                </div>
            );
        }
    };

    getInventoryAssetAccountField = () => {
        if (!this.props.supplierModel.Supplier_Integration.has_qbo) {
            return null;
        }

        if (!this.state.qboOtherCurrentAssetAccounts?.length) {
            return (
                <div className="col-12">
                    <OwLabel leftIconClass={"far fa-circle-notch fa-spin"} title={"loading_default_inventory_asset_account_options"} />
                </div>
            );
        } else {
            return (
                <div className="col-12">
                    <div>
                        <div className={"col-12"}>
                            <OwLabel className={"me-2"} title={"default_inventory_asset_account"} />

                            <WhatsThis subject={"help_text_qbo_default_inventory_asset_account"} />
                        </div>
                        <div className={"col-12 mb-2"}>
                            {this.state.qboOtherCurrentAssetAccounts ? (
                                <OwSelectOption
                                    options={this.state.qboOtherCurrentAssetAccounts}
                                    valueProp={"Id"}
                                    titleProp={"Name"}
                                    fn={this.handleChange}
                                    selectedOption={this.state}
                                    selectedOptionProp={"qbo_InventoryAssetAccountId"}
                                    name={"qbo_InventoryAssetAccountId"}
                                    showBlankFirst={true}
                                />
                            ) : null}
                        </div>
                        <div className={"col-12"}>
                            <OwButton
                                disableOnActive={true}
                                active={this.state.saveInventoryAssetAcctActive}
                                fn={this.saveQboInventoryAssetAcct}
                                title={"save"}
                            />
                        </div>
                    </div>
                </div>
            );
        }
    };

    getCOGSAccountField = () => {
        if (!this.props.supplierModel.Supplier_Integration.has_qbo) {
            return null;
        }

        if (!this.state.qboCOGSAccounts?.length) {
            return (
                <div className="col-12">
                    <OwLabel leftIconClass={"far fa-circle-notch fa-spin"} title={"loading_cogs_account_options"} />
                </div>
            );
        } else {
            return (
                <div className="col-12">
                    <div>
                        <div className={"col-12"}>
                            <OwLabel className={"me-2"} title={"default_cogs_account"} />

                            <WhatsThis subject={"help_text_qbo_default_cogs_account"} />
                        </div>
                        <div className={"col-12 mb-2"}>
                            {this.state.qboCOGSAccounts ? (
                                <OwSelectOption
                                    options={this.state.qboCOGSAccounts}
                                    valueProp={"Id"}
                                    titleProp={"Name"}
                                    fn={this.handleChange}
                                    selectedOption={this.state}
                                    selectedOptionProp={"qbo_COGSAccountId"}
                                    name={"qbo_COGSAccountId"}
                                    showBlankFirst={true}
                                />
                            ) : null}
                        </div>
                        <div className={"col-12"}>
                            <OwButton
                                disableOnActive={true}
                                active={this.state.saveCOGSAccountActive}
                                fn={this.saveQBOCOGSAccount}
                                title={"save"}
                            />
                        </div>
                    </div>
                </div>
            );
        }
    };

    getAPAccountField = () => {
        if (!this.props.supplierModel.Supplier_Integration.has_qbo) {
            return null;
        }

        if (!this.state.qboAPAccounts?.length) {
            return (
                <div className="col-12">
                    <OwLabel leftIconClass={"far fa-circle-notch fa-spin"} title={"loading_ap_account_options"} />
                </div>
            );
        } else {
            return (
                <div className="col-12">
                    <div>
                        <div className={"col-12"}>
                            <OwLabel className={"me-2"} title={"default_ap_account"} />

                            <WhatsThis subject={"help_text_qbo_default_ap_account"} />
                        </div>
                        <div className={"col-12 mb-2"}>
                            {this.state.qboAPAccounts ? (
                                <OwSelectOption
                                    options={this.state.qboAPAccounts}
                                    valueProp={"Id"}
                                    titleProp={"Name"}
                                    fn={this.handleApChange}
                                    selectedOption={this.state.qbo_po_default_ap_account}
                                    selectedOptionProp={"Id"}
                                    emitObject={true}
                                    name={"qbo_po_default_ap_account"}
                                    showBlankFirst={true}
                                />
                            ) : null}
                        </div>
                        <div className={"col-12"}>
                            <OwButton
                                disableOnActive={true}
                                active={this.state.saveAPAccountActive}
                                fn={this.saveQBOAPAccount}
                                title={"save"}
                            />
                        </div>
                    </div>
                </div>
            );
        }
    };

    getAutoSalesTaxField = () => {
        if (!this.props.supplierModel.Supplier_Integration.has_qbo) {
            return null;
        }

        return (
            <div className="col-12 mb-5">
                <div>
                    <div className={"col-12 mb-2"}>
                        <OwToggle
                            fn={this.handleChange}
                            name={"qbo_UsingAutoSalesTax"}
                            label={"using_auto_sales_tax"}
                            active={!!this.props.supplierModel.Supplier_Integration.qbo_UsingAutoSalesTax}
                            labelOnRight={true}
                        />
                    </div>
                    <div className={"col-12"}>
                        <WhatsThis subject={"help_text_qbo_using_auto_sales_tax"} />
                    </div>
                    {this.props.supplierModel.sales_tax_config?.shippingTaxable ? (
                        <div className={"d-flex align-items-center mb-2"}>
                            <OwToggle
                                fn={this.handleChange}
                                name={"qbo_TaxOnShippingAdjustment"}
                                label={"tax_on_shipping_adjustment"}
                                active={!!this.props.supplierModel.Supplier_Integration.qbo_TaxOnShippingAdjustment}
                                labelOnRight={true}
                            />
                            <OwIconTooltip
                                iconClassName={"ms-2 fas fa-info-circle"}
                                tooltipContent={"tax_on_shipping_adjustment_tooltip"}
                                translateContent={true}
                            />
                        </div>
                    ) : null}
                    <div className={"col-12"}>
                        <OwButton disableOnActive={true} active={this.state.activeAutoSalesTax} fn={this.saveAutoSalesTax} title={"save"} />
                    </div>
                    {this.state.qbo_UsingAutoSalesTax ? null : (
                        <div className="col-12">
                            {this.props.supplierModel.tax_rate ? (
                                <div>
                                    <OwLabel title={"no_auto_sales_tax_but_tax_rate_set"} postText={":"} />{" "}
                                    {this.props.supplierModel.tax_rate}%
                                </div>
                            ) : null}
                        </div>
                    )}
                </div>
            </div>
        );
    };

    getDefaultSalesTerms = () => {
        if (!this.state.qboTermOptions?.length && !this.state.qboTermOptionsLoaded) {
            return (
                <div className="col-12">
                    <OwLabel leftIconClass={"far fa-circle-notch fa-spin"} title={"loading_sales_term_options"} />
                </div>
            );
        } else {
            return (
                <div className="col-12">
                    <div>
                        <div className={"col-12"}>
                            <OwLabel className={"me-2"} title={"default_sale_terms"} />

                            <WhatsThis subject={"help_text_qbo_default_sale_terms"} />
                        </div>
                        <div className={"col-12 mb-2"}>
                            <OwSelectOption
                                options={this.state.qboTermOptions}
                                valueProp={"Id"}
                                titleProp={"Name"}
                                fn={this.handleChange}
                                selectedOption={this.state}
                                selectedOptionProp={"qbo_DefaultTermId"}
                                name={"qbo_DefaultTermId"}
                                showBlankFirst={true}
                            />
                        </div>
                        <div className={"col-12"}>
                            <OwButton
                                disabled={this.state.saveTermFieldActive}
                                active={this.state.saveTermFieldActive}
                                fn={this.saveQboTerm}
                                title={"save"}
                            />
                        </div>
                    </div>
                </div>
            );
        }
    };

    poCustomField = () => {
        if (this.state.getCustomFieldsActive) {
            return (
                <div className="col-12">
                    <OwLabel leftIconClass={"far fa-circle-notch fa-spin"} title={"loading_custom_sales_fields"} />
                </div>
            );
        } else {
            return (
                <div className="col-12">
                    <div>
                        <div className={"col-12"}>
                            <OwLabel className={"me-2"} title={"po_invoice_custom_field"} />

                            <WhatsThis subject={"help_text_qbo_po_invoice_custom_field"} />
                        </div>
                        <div className={"col-12 mb-2"}>
                            <OwSelectOption
                                options={this.state.qboCustomSalesFields}
                                valueProp={"Id"}
                                titleProp={"Name"}
                                fn={this.handleChange}
                                selectedOption={this.state}
                                selectedOptionProp={"qbo_POCustomFieldId"}
                                name={"qbo_POCustomFieldId"}
                                showBlankFirst={true}
                            />
                        </div>
                        <div className={"col-12"}>
                            <OwButton
                                disabled={this.state.saveCustomFieldActive}
                                active={this.state.saveCustomFieldActive}
                                fn={this.saveCustomSalesField}
                                title={"save"}
                            />
                        </div>
                    </div>
                </div>
            );
        }
    };

    toggleQboHowTo = (field: string) => {
        // @ts-expect-error
        const selectedField = this.state[field];

        const state: any = {
            // @ts-expect-error
            [field]: !selectedField,
        };

        this.setState(state);
    };

    changeSalesRepField = (e: ChangeEvent<any>) => {
        const value = e.target.value;
        const name = e.target.name;

        const salesRepField = this.state.qboCustomSalesFields.find((field) => {
            return field.Id === value;
        });

        if (salesRepField && salesRepField.Id && salesRepField.Name) {
            const state: any = {
                qbo_SalesRepCustomFieldName: salesRepField.Name,
                qbo_SalesRepCustomFieldId: salesRepField.Id,
            };

            this.setState(state);
        }
    };

    changeRepGroupField = (e: ChangeEvent<any>) => {
        const value = e.target.value;
        const name = e.target.name;

        const repGroupField = this.state.qboCustomSalesFields.find((field) => {
            return field.Id === value;
        });

        if (repGroupField) {
            const state: any = {
                qbo_RepGroupCustomFieldName: repGroupField?.Name,
                qbo_RepGroupCustomFieldId: repGroupField?.Id,
            };

            this.setState(state);
        }
    };

    saveRepGroupField = () => {
        const repGroupField = this.state.qboCustomSalesFields.find((field) => {
            return field.Id === this.state.qbo_RepGroupCustomFieldId;
        });

        if (repGroupField && repGroupField.Id && repGroupField.Name) {
            const payload: IUpdateSupplierIntegrationsDTO = {
                userToken: this.props.userModel.token,
                userGuid: this.props.userModel.guid,
                supplierGuid: this.props.supplierModel.guid,
                // @ts-expect-error
                Supplier_Integration: {
                    qbo_RepGroupCustomFieldName: repGroupField.Name,
                    qbo_RepGroupCustomFieldId: this.state.qbo_RepGroupCustomFieldId,
                },
            };

            this.props.socket.emit(EndpointsEnum.SupplierUpdateSupplierIntegrations, payload);

            this.setState({
                saveCustomFieldActive: true,
            });
        }
    };

    getCustomSalesFieldByName = (Name: string) => {
        return this.state.qboRawCustomSalesFields.find((field) => field.StringValue === Name);
    };

    saveCustomFields = () => {
        const customFieldOne = this.state.qbo_CustomFieldValueOne
            ? this.getCustomSalesFieldByName(this.state.qbo_CustomFieldValueOne)
            : null;
        const customFieldTwo = this.state.qbo_CustomFieldValueTwo
            ? this.getCustomSalesFieldByName(this.state.qbo_CustomFieldValueTwo)
            : null;
        const customFieldThree = this.state.qbo_CustomFieldValueThree
            ? this.getCustomSalesFieldByName(this.state.qbo_CustomFieldValueThree)
            : null;

        const payload: IUpdateSupplierIntegrationsDTO = {
            userToken: this.props.userModel.token,
            userGuid: this.props.userModel.guid,
            supplierGuid: this.props.supplierModel.guid,
            // @ts-expect-error
            Supplier_Integration: {
                qbo_CustomFieldOne: customFieldOne,
                qbo_CustomFieldTwo: customFieldTwo,
                qbo_CustomFieldThree: customFieldThree,
                qbo_ow_num_as_invoice_ref: this.state.qbo_ow_num_as_invoice_ref,
                qbo_AllowAchPayments: this.state.qbo_AllowAchPayments,
                qbo_use_ow_quote_num_for_estimate: this.state.qbo_use_ow_quote_num_for_estimate,
                qbo_hide_quote_ow_btns: this.state.qbo_hide_quote_ow_btns,
                qbo_quote_for_est_name: this.state.qbo_quote_for_est_name,
                qbo_invoice_memo: this.state.qbo_invoice_memo,
                qbo_customer_name_field: this.state.qbo_customer_name_field,
                qbo_grouped_invoices: this.state.qbo_grouped_invoices,
                // qbo_grouped_invoices_by_day: this.state.qbo_grouped_invoices_by_day,
                qbo_grouped_invoice_type: this.state.qbo_grouped_invoice_type,
                qbo_invoice_default_date: this.state.qbo_invoice_default_date,
                qbo_invoice_default_ship_date: this.state.qbo_invoice_default_ship_date,
                qbo_GlobalTaxCalculationEnum: this.state.qbo_GlobalTaxCalculationEnum,
            },
        };

        payload.Supplier_Integration.qbo_shipping_catalog_item_id = this.state.selectedShippingItem
            ? this.state.selectedShippingItem.id
            : null;

        this.props.socket.emit(EndpointsEnum.SupplierUpdateSupplierIntegrations, payload);

        this.setState({
            saveCustomFieldActive: true,
        });
    };

    saveAutoPullOptions = () => {
        const payload: IUpdateSupplierIntegrationsDTO = {
            userToken: this.props.userModel.token,
            userGuid: this.props.userModel.guid,
            supplierGuid: this.props.supplierModel.guid,
            // @ts-expect-error
            Supplier_Integration: {
                qbo_auto_pull_products: this.state.qbo_auto_pull_products,
                qbo_auto_pull_customers: this.state.qbo_auto_pull_customers,
                qbo_update_accounts_on_save: this.state.qbo_update_accounts_on_save,
                qbo_using_classes: this.state.qbo_using_classes,
                qbo_push_inventory_updates: this.state.qbo_push_inventory_updates,
                qbo_skip_inventory_updates: this.state.qbo_skip_inventory_updates,
            },
        };

        this.props.socket.emit(EndpointsEnum.SupplierUpdateSupplierIntegrations, payload);

        this.setState({
            saveCustomFieldActive: true,
        });
    };

    saveSalesRepField = () => {
        const salesRepField = this.state.qboCustomSalesFields.find((field) => {
            return field.Id === this.state.qbo_SalesRepCustomFieldId;
        });

        if (salesRepField) {
            const payload: IUpdateSupplierIntegrationsDTO = {
                userToken: this.props.userModel.token,
                userGuid: this.props.userModel.guid,
                supplierGuid: this.props.supplierModel.guid,
                // @ts-expect-error
                Supplier_Integration: {
                    qbo_SalesRepCustomFieldName: salesRepField.Name,
                    qbo_SalesRepCustomFieldId: this.state.qbo_SalesRepCustomFieldId,
                },
            };

            this.props.socket.emit(EndpointsEnum.SupplierUpdateSupplierIntegrations, payload);

            this.setState({
                saveCustomFieldActive: true,
            });
        }
    };

    getRepGroupField = () => {
        if (!this.props.supplierModel.has_rep_groups) {
            return null;
        }

        return (
            <div className={"col-12"}>
                <div className={"col-12"}>
                    <div>
                        <OwLabel className={"me-2"} title={"rep_group_custom_field"} />

                        <WhatsThis subject={"help_text_rep_group_custom_field"} />
                    </div>
                    <div className={"mb-2"}>
                        <OwSelectOption
                            options={this.state.qboCustomSalesFields}
                            valueProp={"Id"}
                            titleProp={"Name"}
                            fn={this.changeRepGroupField}
                            selectedOption={this.state}
                            selectedOptionProp={"qbo_RepGroupCustomFieldId"}
                            name={"qbo_RepGroupCustomFieldName"}
                            showBlankFirst={true}
                        />
                    </div>
                    <div className={""}>
                        <OwButton
                            disabled={this.state.saveCustomFieldActive}
                            active={this.state.saveCustomFieldActive}
                            fn={this.saveRepGroupField}
                            title={"save"}
                        />
                    </div>
                </div>
            </div>
        );
    };

    getSalesRepField = () => {
        if (!this.props.supplierModel.has_rep_groups) {
            return null;
        }

        return (
            <div className={"col-12"}>
                <div className={"col-12"}>
                    <div>
                        <OwLabel className={"me-2"} title={"sales_rep_custom_field"} />

                        <WhatsThis subject={"help_text_sales_rep_custom_field"} />
                    </div>
                    <div className={"mb-2"}>
                        <OwSelectOption
                            options={this.state.qboCustomSalesFields}
                            valueProp={"Id"}
                            titleProp={"Name"}
                            fn={this.changeSalesRepField}
                            selectedOption={this.state}
                            selectedOptionProp={"qbo_SalesRepCustomFieldId"}
                            name={"qbo_SalesRepCustomFieldName"}
                            showBlankFirst={true}
                        />
                    </div>
                    <div className={""}>
                        <OwButton
                            disabled={this.state.saveCustomFieldActive}
                            active={this.state.saveCustomFieldActive}
                            fn={this.saveSalesRepField}
                            title={"save"}
                        />
                    </div>
                </div>
            </div>
        );
    };

    handleApChange = (obj: any) => {
        this.setState({
            qbo_po_default_ap_account: obj,
        });
    };

    handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.value;
        const name = e.target.name;

        const state: any = {
            [name]: value,
        };

        this.setState(state, () => {
            if (name === "catalog_id") {
                this.getPriceGroups();
            }
        });
    };

    clearShippingItem = () => {
        this.setState({
            selectedShippingItem: null,
        });
    };

    handleShippingItemSelect = (item: ICatalog_Item) => {
        this.setState({
            selectedShippingItem: item,
        });
    };

    shippingItemLookup = (name: string) => {
        if (this.state.catalog_id && this.state.catalogs) {
            const catalogModel = this.state.catalogs.find((catalog) => {
                return catalog.id === this.state.catalog_id;
            });

            if (catalogModel) {
                const payload: ITypeaheadCatalogItemDTO = {
                    userToken: this.props.userModel.token,
                    userGuid: this.props.userModel.guid,
                    supplierGuid: this.props.supplierModel.guid,
                    name,
                    catalogGuid: catalogModel.guid,
                    options: {
                        searchName: true,
                        searchDescription: true,
                        searchSku: true,
                        searchUpc: true,
                    },
                };

                this.props.socket.emit(EndpointsEnum.CatalogItemTypeaheadCatalogItem, payload);
            }
        }
    };

    onShippingItemLookup = (data: IOnTypeaheadCatalogItemDTO) => {
        this.setState({
            foundShippingItems: data.catalog_items,
        });
    };

    forceCustomFieldActive = (index: 1 | 2 | 3) => {
        const payload: IQBOForceCustomFieldActiveDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            customFieldNumber: index,
        };

        this.props.socket.emit(EndpointsEnum.QBOForceCustomFieldActive, payload);
    };

    onForceCustomFieldActive = (data: IQBOForceCustomFieldActiveDTO) => {
        const notification: INotification = {
            message: "successfully_forced_custom_field_active",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        this.props.notifyFn(null, notification);
    };

    getPreferences = () => {
        const payload: IQBOGetPreferencesDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.QBOGetPreferences, payload);
    };

    onGetPreferences = (data: IQBOOnGetPreferencesDTO) => {
        console.log(data);
    };

    render() {
        let supplierIntegrations: any = {};

        if (!_.isNil(this.props.supplierModel)) {
            supplierIntegrations = this.props.supplierModel.Supplier_Integration || {};
        }

        let logo = quickbooksLogo;

        if (this.props.isMainViewLight) {
            logo = quickbooksLightLogo;
        }

        const hasQbo = !!supplierIntegrations.has_qbo;

        const qboCustomerNameFieldOptions = [
            { value: "DisplayName", title: "Display Name" },
            { value: "CompanyName", title: "Company Name" },
        ];

        return (
            <div className="QuickbooksConnect">
                <OwAccordion
                    hideChevron={!hasQbo}
                    leftImage={logo}
                    leftImageHeight={35}
                    leftImageAlt={"QuickBooks Online"}
                    titleClick={hasQbo}
                    rightElem={
                        <div className={"ms-auto"}>
                            {hasQbo ? (
                                <OwBadge title={"connected"} leftIconClass={"fas fa-check"} bgColor={"bg-success"} />
                            ) : (
                                <div>
                                    <OwToggle
                                        name={"enable_payments"}
                                        label={"enable_payments"}
                                        active={this.state.enable_payments}
                                        fn={this.handleChange}
                                        labelOnRight={true}
                                    />

                                    <div className={"mt-2"}>
                                        <button className="btn-qb pointer" onClick={this.startQBConnect}>
                                            <img src={qbBtnDefault} alt="Quickbooks Connect" height={40} />
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    }>
                    <div className={"w-25"}>
                        <div className={"detail-section"}>
                            <div className={supplierIntegrations.has_qbo ? "" : "d-none"}>
                                <div className={"mt-4"}>
                                    <OwButton
                                        minWidth={225}
                                        className={"btn-danger"}
                                        fn={this.disconnectQuickbooks}
                                        leftIconClass={"fas fa-unlink"}
                                        title={"business.disconnect_quickbooks"}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    {supplierIntegrations.has_qbo ? (
                        <div className={"mt-5 col-12 col-md-4"}>
                            <div className={"col-12 d-flex flex-column"}>
                                <div className={""}>
                                    <OwLabel
                                        title={"has_qbo_payments"}
                                        className={supplierIntegrations.has_qbo_payments ? "text-success" : "text-danger"}
                                        leftIconClass={supplierIntegrations.has_qbo_payments ? "fas fa-check" : "fas fa-times"}
                                    />
                                    {supplierIntegrations.has_qbo_payments ? null : (
                                        <WhatsThis subject={"help_text_has_quickbooks_payments"} />
                                    )}
                                </div>
                                {/*<OwToggle*/}
                                {/*    fn={this.toggleQBOPayments}*/}
                                {/*    name={"has_qbo_payments"}*/}
                                {/*    label={""}*/}
                                {/*    active={supplierIntegrations.has_qbo_payments}*/}
                                {/*    disabled={true}*/}
                                {/*/>*/}
                            </div>
                        </div>
                    ) : null}

                    <div className={"col-12 col-md-4"}>
                        {this.props.showHiddenFeatures ? (
                            <div>
                                <OwButton title={"get_preferences"} fn={this.getPreferences} />

                                <div className={"mt-2"}>
                                    <div className={"mb-2"}>
                                        <OwButton
                                            title={"force_custom_field_one_active"}
                                            fn={() => {
                                                this.forceCustomFieldActive(1);
                                            }}
                                        />
                                    </div>
                                    <div className={"mb-2"}>
                                        <OwButton
                                            title={"force_custom_field_two_active"}
                                            fn={() => {
                                                this.forceCustomFieldActive(2);
                                            }}
                                        />
                                    </div>
                                    <div className={"mb-2"}>
                                        <OwButton
                                            title={"force_custom_field_three_active"}
                                            fn={() => {
                                                this.forceCustomFieldActive(3);
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        ) : null}

                        <div className={"mb-5 mt-5"}>{this.state.incomeAccountComponent}</div>

                        <div className={"mb-5"}>{this.state.termsComponent}</div>

                        <div className={"mb-5"}>{this.state.poFieldComponent}</div>

                        <div className={"mb-5"}>{this.getInventoryAssetAccountField()}</div>

                        <div className={"mb-5"}>{this.getCOGSAccountField()}</div>

                        <div className={"mb-5"}>{this.getAPAccountField()}</div>

                        <div className="mg-5">{this.getAutoSalesTaxField()}</div>

                        {supplierIntegrations.has_qbo && this.props.supplierModel.has_rep_groups ? (
                            <div className={"mb-5"}>{this.getSalesRepField()}</div>
                        ) : null}
                    </div>

                    {/*<div className={"mb-5"}>{this.getRepGroupField()}</div>*/}

                    {supplierIntegrations.has_qbo ? (
                        <div className={"col-12 col-md-4"}>
                            <div className={"col-12"}>
                                <OwLabel title={"default_price_group"} />
                                <WhatsThis subject={"help_text_qbo_default_price_group"} />
                                <div>
                                    <OwLabel title={"catalogs"} />
                                    <OwSelectOption
                                        titleProp={"name"}
                                        valueProp={"id"}
                                        options={this.state.catalogs}
                                        fn={this.handleChange}
                                        name={"catalog_id"}
                                        selectedOption={this.state}
                                        selectedOptionProp={"catalog_id"}
                                        emitOnLoad={true}
                                        emitTarget={true}
                                        showBlankFirst={true}
                                    />
                                </div>
                                <div className={"mt-4"}>
                                    <OwLabel title={"price_groups"} />
                                    <OwSelectOption
                                        titleProp={"value"}
                                        valueProp={"id"}
                                        options={this.state.priceGroups}
                                        fn={this.handleChange}
                                        name={"price_group_id"}
                                        selectedOption={this.state}
                                        selectedOptionProp={"price_group_id"}
                                        emitTarget={true}
                                        emitOnLoad={true}
                                        showBlankFirst={true}
                                    />
                                </div>
                                <div className={"mt-2"}>
                                    <OwButton
                                        disabled={this.state.saveDefaultPriceGroupActive}
                                        active={this.state.saveDefaultPriceGroupActive}
                                        fn={this.saveDefaultPriceGroup}
                                        title={"save"}
                                    />
                                </div>
                                <div className={"mt-4"}>
                                    <div className={"mb-2"}>
                                        <OwToggle
                                            fn={this.handleChange}
                                            name={"qbo_using_classes"}
                                            label={"using_classes"}
                                            active={!!this.props.supplierModel.Supplier_Integration.qbo_using_classes}
                                            labelOnRight={true}
                                        />
                                    </div>
                                    <div className={"mb-2"}>
                                        <OwToggle
                                            fn={this.handleChange}
                                            name={"qbo_auto_pull_products"}
                                            label={"auto_pull_products"}
                                            active={!!this.props.supplierModel.Supplier_Integration.qbo_auto_pull_products}
                                            labelOnRight={true}
                                        />
                                    </div>
                                    <div className={"mb-2"}>
                                        <OwToggle
                                            fn={this.handleChange}
                                            name={"qbo_auto_pull_customers"}
                                            label={"auto_pull_customers"}
                                            active={!!this.props.supplierModel.Supplier_Integration.qbo_auto_pull_customers}
                                            labelOnRight={true}
                                        />
                                    </div>
                                    <div className={"mb-2"}>
                                        <OwToggle
                                            fn={this.handleChange}
                                            name={"qbo_update_accounts_on_save"}
                                            label={"auto_update_accounts_on_save"}
                                            active={!!this.props.supplierModel.Supplier_Integration.qbo_update_accounts_on_save}
                                            labelOnRight={true}
                                        />
                                    </div>
                                    <div className={"mb-2"}>
                                        <OwToggle
                                            fn={this.handleChange}
                                            name={"qbo_push_inventory_updates"}
                                            label={"auto_push_inventory_updates"}
                                            active={!!this.props.supplierModel.Supplier_Integration.qbo_push_inventory_updates}
                                            labelOnRight={true}
                                        />
                                    </div>
                                    <div className={"mb-2"}>
                                        <OwToggle
                                            fn={this.handleChange}
                                            name={"qbo_skip_inventory_updates"}
                                            label={"skip_inventory_sync"}
                                            active={!!this.props.supplierModel.Supplier_Integration.qbo_skip_inventory_updates}
                                            labelOnRight={true}
                                        />
                                        <WhatsThis subject={"help_text_qbo_skip_inventory_sync"} />
                                    </div>
                                    <div className={""}>
                                        <OwButton disableOnActive={true} fn={this.saveAutoPullOptions} title={"save"} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : null}
                    {supplierIntegrations.has_qbo ? (
                        <div className={"mt-5 col-12 col-md-4"}>
                            <div className={"col-12"}>
                                <OwLabel title={"order_entry_custom_field_one"} />
                                <div>
                                    <OwSelectOption
                                        name={"qbo_CustomFieldValueOne"}
                                        titleProp={"Name"}
                                        valueProp={"Name"}
                                        options={this.state.qboCustomSalesFields}
                                        fn={this.handleChange}
                                        selectedOption={this.state}
                                        selectedOptionProp={"qbo_CustomFieldValueOne"}
                                    />
                                </div>
                            </div>
                            <div className={"col-12 mt-3"}>
                                <OwLabel title={"order_entry_custom_field_two"} />
                                <div>
                                    <OwSelectOption
                                        name={"qbo_CustomFieldValueTwo"}
                                        titleProp={"Name"}
                                        valueProp={"Name"}
                                        options={this.state.qboCustomSalesFields}
                                        fn={this.handleChange}
                                        selectedOption={this.state}
                                        selectedOptionProp={"qbo_CustomFieldValueTwo"}
                                    />
                                </div>
                            </div>
                            <div className={"col-12 mt-3"}>
                                <OwLabel title={"order_entry_custom_field_two"} />
                                <div>
                                    <OwSelectOption
                                        name={"qbo_CustomFieldValueThree"}
                                        titleProp={"Name"}
                                        valueProp={"Name"}
                                        options={this.state.qboCustomSalesFields}
                                        fn={this.handleChange}
                                        selectedOption={this.state}
                                        selectedOptionProp={"qbo_CustomFieldValueThree"}
                                    />
                                </div>
                            </div>
                            <div className={"col-12 mt-3"}>
                                <OwToggle
                                    fn={this.handleChange}
                                    name={"qbo_ow_num_as_invoice_ref"}
                                    label={"use_ow_num_as_invoice_ref"}
                                    active={this.state.qbo_ow_num_as_invoice_ref}
                                    labelOnRight={true}
                                />
                            </div>
                            <div className={"col-12 mt-3"}>
                                <OwLabel title={"default_invoice_memo"} />
                                <OwTextArea value={this.state.qbo_invoice_memo} name={"qbo_invoice_memo"} fn={this.handleChange} />
                            </div>
                            <div className={"col-12 mt-3"}>
                                <OwToggle
                                    fn={this.handleChange}
                                    name={"qbo_use_ow_quote_num_for_estimate"}
                                    label={"qbo_use_ow_quote_no_as_estimate_no"}
                                    active={this.state.qbo_use_ow_quote_num_for_estimate}
                                    labelOnRight={true}
                                />
                            </div>
                            <div className={"col-12 mt-3"}>
                                <OwToggle
                                    fn={this.handleChange}
                                    name={"qbo_AllowAchPayments"}
                                    label={"allow_ach_payments"}
                                    active={this.state.qbo_AllowAchPayments}
                                    labelOnRight={true}
                                />
                            </div>
                            <div className={"col-12 mt-3"}>
                                <OwToggle
                                    fn={this.handleChange}
                                    name={"qbo_quote_for_est_name"}
                                    label={"qbo_quote_for_est_name"}
                                    active={this.state.qbo_quote_for_est_name}
                                    labelOnRight={true}
                                />
                            </div>
                            <div className={"col-12 mt-3"}>
                                <OwToggle
                                    fn={this.handleChange}
                                    name={"qbo_hide_quote_ow_btns"}
                                    label={"qbo_hide_quote_ow_btns"}
                                    active={this.state.qbo_hide_quote_ow_btns}
                                    labelOnRight={true}
                                />
                            </div>
                            <div className={"col-12 mt-3"}>
                                <OwToggle
                                    fn={this.handleChange}
                                    name={"qbo_grouped_invoices"}
                                    label={"qbo_grouped_invoices"}
                                    active={this.state.qbo_grouped_invoices}
                                    labelOnRight={true}
                                />
                            </div>
                            {this.state.qbo_grouped_invoices ? (
                                <div className={"col-12 mt-3"}>
                                    {/*<div>*/}
                                    {/*    <OwToggle*/}
                                    {/*        fn={this.handleChange}*/}
                                    {/*        name={"qbo_grouped_invoices_by_day"}*/}
                                    {/*        label={"group_by_day"}*/}
                                    {/*        active={this.state.qbo_grouped_invoices_by_day}*/}
                                    {/*        labelOnRight={true}*/}
                                    {/*    />*/}
                                    {/*</div>*/}
                                    <div>
                                        <OwLabel title={"grouped_invoice_type"} />
                                        <OwSelectOption
                                            options={[
                                                { value: QBOGroupedInvoiceTypeEnum.STANDARD, title: "standard" },
                                                { value: QBOGroupedInvoiceTypeEnum.SUM_BY_ORDER, title: "sum_by_order" },
                                                { value: QBOGroupedInvoiceTypeEnum.GROUPED_BY_DAY, title: "group_by_day" },
                                            ]}
                                            translateTitle={true}
                                            selectedOption={this.state}
                                            selectedOptionProp={"qbo_grouped_invoice_type"}
                                            titleProp={"title"}
                                            valueProp={"value"}
                                            fn={this.handleChange}
                                            name={"qbo_grouped_invoice_type"}
                                        />
                                    </div>
                                </div>
                            ) : null}
                            {this.state.catalog_id ? (
                                <div className={"col-12 mt-3"}>
                                    <OwLabel title={"shipping_item"} />
                                    <Typeahead
                                        isSelectableFn={() => true}
                                        typeaheadApiFn={this.shippingItemLookup}
                                        typeaheadItems={this.state.foundShippingItems}
                                        titleProp={"name"}
                                        subTitleProp={"sku"}
                                        selectedItemFn={this.handleShippingItemSelect}
                                        selectedItem={this.state.selectedShippingItem}
                                        selectedItemTitleProp={"name"}
                                        placeholder={"shipping_item"}
                                        clearTypeahead={this.state.clearShippingItem}
                                        clearTypeaheadCallback={this.clearShippingItem}
                                    />
                                </div>
                            ) : null}
                            <div className={"col-12 mt-3"}>
                                <OwLabel title={"customer_name_field"} />
                                <WhatsThis subject={"help_text_qbo_customer_name_field"} />
                                <div className={"mt-2"}>
                                    <OwSelectOption
                                        name={"qbo_customer_name_field"}
                                        titleProp={"title"}
                                        valueProp={"value"}
                                        options={qboCustomerNameFieldOptions}
                                        fn={this.handleChange}
                                        selectedOption={this.state}
                                        selectedOptionProp={"qbo_customer_name_field"}
                                    />
                                </div>
                            </div>
                            <div className={"col-12 mt-3"}>
                                <OwLabel title="default_invoice_date_field" />
                                <WhatsThis subject="help_text_qbo_default_invoice_date_field" />
                                <div className={"mt-2"}>
                                    <OwSelectOption
                                        name={"qbo_invoice_default_date"}
                                        titleProp={"title"}
                                        valueProp={"value"}
                                        fn={this.handleChange}
                                        translateTitle={true}
                                        selectedOption={this.state}
                                        selectedOptionProp={"qbo_invoice_default_date"}
                                        options={this.qboInvoiceDateFieldOptions}
                                    />
                                </div>
                            </div>
                            <div className={"col-12 mt-3"}>
                                <OwLabel title="default_invoice_ship_date_field" />
                                <WhatsThis subject="help_text_qbo_default_invoice_ship_date_field" />
                                <div className={"mt-2"}>
                                    <OwSelectOption
                                        name={"qbo_invoice_default_ship_date"}
                                        titleProp={"title"}
                                        valueProp={"value"}
                                        translateTitle={true}
                                        fn={this.handleChange}
                                        selectedOption={this.state}
                                        selectedOptionProp={"qbo_invoice_default_ship_date"}
                                        options={this.qboInvoiceDateFieldOptions}
                                    />
                                </div>
                            </div>
                            <div className={"col-12 mt-3"}>
                                <OwLabel title="global_tax_calculation" />
                                <WhatsThis subject="help_text_qbo_global_tax_calculation" />
                                <div className={"text-muted small mb-1"}>
                                    <OwLabel title="for_non_us_customers" />
                                </div>
                                <div className={"mt-2"}>
                                    <OwSelectOption
                                        name={"qbo_GlobalTaxCalculationEnum"}
                                        titleProp={"title"}
                                        valueProp={"value"}
                                        translateTitle={true}
                                        fn={this.handleChange}
                                        selectedOption={this.state}
                                        selectedOptionProp={"qbo_GlobalTaxCalculationEnum"}
                                        options={this.qboGlobalTaxCalcOptions}
                                        showBlankFirst={true}
                                    />
                                </div>
                            </div>
                            <div className={"col-12 mt-2"}>
                                <OwButton
                                    disableOnActive={true}
                                    active={this.state.saveCustomFieldActive}
                                    fn={this.saveCustomFields}
                                    title={"save"}
                                />
                            </div>
                        </div>
                    ) : null}
                </OwAccordion>
            </div>
        );
    }
}

export default QuickbooksConnect;
